// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/graduation-cap.js';

import { paths } from '../generated/graduation-cap';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('graduation-cap', Original, paths);
